import './App.css';
import React from 'react';

import '../assets/css/material.css';
import '../assets/css/custom.css';
import '../assets/css/material.js';
import '../assets/css/select.css';
import '../assets/css/select.js';

import {
    BROADCAST_ACTION_DATA_SAVED,
    BROADCAST_USER_ACTION_EXECUTED, PAGE_DELETE_ACCOUNT,
    PAGE_START, PAGE_VILLAGE, PAGE_IMPRESSUM, PAGE_DATENSCHUTZ, PAGE_AGB,
    PAGES,
    USER_ACTION_ERROR_OCCURRED, PAGE_CONTACT,
} from "./basic/consts";
import MyErrorBoundary from "./MyErrorBoundary";
import UIToast from "./views/_commons/Toast/UIToast";
import UIDeleteAccountView from "./views/delete-account/UIDeleteAccountView";
import UIHomeView from "./views/home/UIHomeView";
import UIVillageView from "./views/village/UIVillageView";
import UIImpressumView from "./views/legal/UIImpressumView";
import UIDatenschutzView from "./views/legal/UIDatenschutzView";
import UIAgbView from "./views/legal/UIAgbView";
import UIContactView from "./views/legal/UIContactView";
import { findVillageBySlug } from "../data/villages";
import UIImpressumAllView from "./views/legal/UIImpressumAllView";

/**
 *
 * session: { }
 *
 */
class App extends React.Component {

    constructor(props) {
        super(props);
        this.toast = React.createRef();
        this.state = {
            page: this.initPage(),
            headerInfo: null,
            initDone : false,
            selectedVillage: this._initialVillage || null,
        }
        this.onUserAction   = this.onUserAction.bind(this);
        this.onPopState     = this.onPopState.bind(this);
    }

    initPage(){
        const pathname = window.location.pathname;

        // Check for village route: /gemeinde/<slug>
        const villageMatch = pathname.match(/^\/gemeinde\/(.+)$/);
        if (villageMatch) {
            const village = findVillageBySlug(villageMatch[1]);
            if (village) {
                this._initialVillage = village;
                return PAGES[PAGE_VILLAGE];
            }
        }

        if (pathname === '/delete-account') return PAGES[PAGE_DELETE_ACCOUNT];
        if (pathname === '/impressum')      return PAGES[PAGE_IMPRESSUM];
        if (pathname === '/datenschutz')    return PAGES[PAGE_IMPRESSUM];
        if (pathname === '/agb')            return PAGES[PAGE_IMPRESSUM];
        if (pathname === '/contact')        return PAGES[PAGE_IMPRESSUM];

        if (pathname !== '/' && pathname !== '/home') {
            window.history.replaceState(null, '', '/');
        }
        return PAGES[PAGE_START];
    }

    componentDidMount() {
        window.addEventListener('popstate', this.onPopState);
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.onPopState);
    }

    onPopState() {
        const pathname = window.location.pathname;
        const villageMatch = pathname.match(/^\/gemeinde\/(.+)$/);
        if (villageMatch) {
            const village = findVillageBySlug(villageMatch[1]);
            if (village) {
                this.setState({ page: PAGES[PAGE_VILLAGE], selectedVillage: village });
                return;
            }
        }
        if (pathname === '/delete-account') {
            this.setState({ page: PAGES[PAGE_DELETE_ACCOUNT], selectedVillage: null });
            return;
        }
        if (pathname === '/impressum' || pathname === '/contact' || pathname === '/datenschutz' || pathname === '/agb') {
            this.setState({ page: PAGES[PAGE_IMPRESSUM], selectedVillage: null });
            return;
        }
        // if (pathname === '/datenschutz') {
        //     this.setState({ page: PAGES[PAGE_DATENSCHUTZ], selectedVillage: null });
        //     return;
        // }
        // if (pathname === '/agb') {
        //     this.setState({ page: PAGES[PAGE_AGB], selectedVillage: null });
        //     return;
        // }

        if (pathname !== '/' && pathname !== '/home') {
            window.history.replaceState(null, '', '/');
        }
        this.setState({ page: PAGES[PAGE_START], selectedVillage: null });
    }

    onUserAction(action, data) {
        if (action === 'page') {
            const currentPath = window.location.pathname;
            if (data === currentPath) {
                window.location.reload();
            } else {
                window.history.pushState(null, '', data);
                this.onPopState();
            }
        } else if (action === USER_ACTION_ERROR_OCCURRED){
            // ignore
        }
    }

    render() {
        const page     = this.state.page;
        document.title = page.name;

        return (
            <MyErrorBoundary>
                <div className="wrapper">
                    <div id={"app-content"}>

                        {page.index === PAGE_START && <UIHomeView onUserAction={this.onUserAction} onVillageSelect={village => {
                            window.history.pushState(null, '', '/gemeinde/' + village.slug);
                            this.setState({ page: PAGES[PAGE_VILLAGE], selectedVillage: village });
                        }}/>}
                        {page.index === PAGE_DELETE_ACCOUNT && <UIDeleteAccountView onUserAction={this.onUserAction}/>}
                        {page.index === PAGE_VILLAGE && <UIVillageView village={this.state.selectedVillage} onBack={() => {
                            window.history.pushState(null, '', '/');
                            this.setState({ page: PAGES[PAGE_START], selectedVillage: null });
                        }}/>}
                        {page.index === PAGE_IMPRESSUM   && <UIImpressumAllView onBack={() => { window.history.back(); }}/>}
                        {page.index === PAGE_DATENSCHUTZ && <UIDatenschutzView onBack={() => { window.history.back(); }}/>}
                        {page.index === PAGE_AGB         && <UIAgbView         onBack={() => { window.history.back(); }}/>}
                        {page.index === PAGE_CONTACT     && <UIContactView     onBack={() => { window.history.back(); }}/>}

                    </div>

                    <UIToast ref={this.toast} />

                </div>
           </MyErrorBoundary>
        );

    }

}

export default App;
